import { __extends } from "tslib";
import { FederatedEvent } from './FederatedEvent';
/**
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationPlaybackEvent
 */

var AnimationEvent =
/** @class */
function (_super) {
  __extends(AnimationEvent, _super);

  function AnimationEvent(manager, target, currentTime, timelineTime) {
    var _this = _super.call(this, manager) || this;

    _this.currentTime = currentTime;
    _this.timelineTime = timelineTime; // @ts-ignore

    _this.target = target;
    _this.type = 'finish';
    _this.bubbles = false; // @ts-ignore

    _this.currentTarget = target;
    _this.defaultPrevented = false;
    _this.eventPhase = _this.AT_TARGET;
    _this.timeStamp = Date.now();
    _this.currentTime = currentTime;
    _this.timelineTime = timelineTime;
    return _this;
  }

  return AnimationEvent;
}(FederatedEvent);

export { AnimationEvent };